import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadStageV2Params = OpalApiRequestParams<'ReadStageV2'>
type ReadStageV2ResponseDocument = OpalApiResponseDocument<'ReadStageV2', 200>

export const readStageById = (
  params: ReadStageV2Params
): Promise<ReadStageV2ResponseDocument> => {
  const url = new URL(
    `/workflows/v2/stages/${params.path.stage_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
